var T = Object.defineProperty;
var A = (e, n, t) => n in e ? T(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var f = (e, n, t) => (A(e, typeof n != "symbol" ? n + "" : n, t), t);
var S = /* @__PURE__ */ ((e) => (e.automation = "automation", e.test = "test", e.vbc = "vbc", e.video = "video", e.voice = "voice", e))(S || {});
const U = "hlg.tokbox.com/prod/logging/vcp_webrtc", v = "https://", N = 1e4;
let d;
const C = new Uint8Array(16);
function O() {
  if (!d && (d = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !d))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return d(C);
}
const o = [];
for (let e = 0; e < 256; ++e)
  o.push((e + 256).toString(16).slice(1));
function M(e, n = 0) {
  return (o[e[n + 0]] + o[e[n + 1]] + o[e[n + 2]] + o[e[n + 3]] + "-" + o[e[n + 4]] + o[e[n + 5]] + "-" + o[e[n + 6]] + o[e[n + 7]] + "-" + o[e[n + 8]] + o[e[n + 9]] + "-" + o[e[n + 10]] + o[e[n + 11]] + o[e[n + 12]] + o[e[n + 13]] + o[e[n + 14]] + o[e[n + 15]]).toLowerCase();
}
const E = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), w = {
  randomUUID: E
};
function L(e, n, t) {
  if (w.randomUUID && !n && !e)
    return w.randomUUID();
  e = e || {};
  const i = e.random || (e.rng || O)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, n) {
    t = t || 0;
    for (let r = 0; r < 16; ++r)
      n[t + r] = i[r];
    return n;
  }
  return M(i);
}
function y(e, n) {
  globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
  let t = globalThis.vonage.workerizer;
  return t[e] || (t[e] = n), t[e];
}
const a = y(
  "globals",
  {}
);
var s = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.FORWARD = "FORWARD", e.TERMINATE = "TERMINATE", e.GLOBALS_SYNC = "GLOBALS_SYNC", e))(s || {});
function I(e) {
  return [ImageBitmap, ReadableStream, WritableStream].some((t) => e instanceof t);
}
let G = 0;
function V(e, n, t, i, r) {
  const c = G++;
  return e.postMessage(
    {
      id: c,
      type: n,
      functionName: t,
      args: i
    },
    i.filter((l) => I(l))
  ), new Promise((l) => {
    r == null || r.set(c, l);
  });
}
function u(e, n) {
  const { id: t, type: i } = e, r = Array.isArray(n) ? n : [n];
  postMessage(
    {
      id: t,
      type: i,
      result: n
    },
    r.filter((c) => I(c))
  );
}
const m = y("workerized", {});
function R() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
async function W() {
  if (R())
    u({ type: s.GLOBALS_SYNC }, a);
  else {
    const e = [];
    for (const n in m) {
      const { worker: t, resolvers: i } = m[n].workerContext;
      t && e.push(
        V(
          t,
          s.GLOBALS_SYNC,
          "",
          [a],
          i
        )
      );
    }
    await Promise.all(e);
  }
}
function g(e, n) {
  if (Array.isArray(n))
    n.splice(0, n.length);
  else if (typeof n == "object")
    for (const t in n)
      delete n[t];
  for (const t in e)
    Array.isArray(e[t]) ? (n[t] = [], g(e[t], n[t])) : typeof e[t] == "object" ? (n[t] = {}, g(e[t], n[t])) : n[t] = e[t];
}
async function D(e, n) {
  const { functionName: t, args: i } = e;
  if (!n.instance)
    throw "instance not initialized";
  if (!t)
    throw "missing function name to call";
  if (!n.instance[t])
    throw `undefined function [${t}] in class ${n.instance.constructor.workerId}`;
  u(e, await n.instance[t](...i != null ? i : []));
}
const _ = y("registeredWorkers", {});
function x(e, n) {
  if (!e.args)
    throw "Missing className while initializing worker";
  const [t, i] = e.args, r = _[t];
  if (r)
    n.instance = new r(e.args.slice(1));
  else
    throw `unknown worker class ${t}`;
  g(i, a), u(e, typeof n.instance !== void 0);
}
async function z(e, n) {
  const { args: t } = e;
  if (!n.instance)
    throw "instance not initialized";
  let i;
  n.instance.terminate && (i = await n.instance.terminate(...t != null ? t : [])), u(e, i);
}
function B(e) {
  if (!e.args)
    throw "Missing globals while syncing";
  g(e.args[0], a), u(e, {});
}
function Y() {
  const e = {};
  onmessage = async (n) => {
    const t = n.data;
    switch (t.type) {
      case s.INIT:
        x(t, e);
        break;
      case s.FORWARD:
        D(t, e);
        break;
      case s.TERMINATE:
        z(t, e);
        break;
      case s.GLOBALS_SYNC:
        B(t);
        break;
    }
  };
}
R() && Y();
function j(e, n) {
  return a[e] || (a[e] = n), [
    () => a[e],
    async (t) => {
      a[e] = t, await W();
    }
  ];
}
function F(e, n) {
  return j(e, n);
}
const [P, $] = F("metadata");
function J(e) {
  $(e);
}
function p() {
  return P();
}
class q {
  constructor(n) {
    f(this, "uuid", L());
    this.config = n;
  }
  async send(n) {
    var l, h, b;
    const { appId: t, sourceType: i } = (l = p()) != null ? l : {};
    if (!t || !i)
      return "metadata missing";
    const r = new AbortController(), c = setTimeout(() => r.abort(), N);
    return await ((b = (h = this.config) == null ? void 0 : h.fetch) != null ? b : fetch)(this.getUrl(), {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(this.buildReport(n)),
      signal: r.signal
    }), clearTimeout(c), "success";
  }
  getUrl() {
    var t;
    let n = (t = p().proxyUrl) != null ? t : v;
    return n += (n.at(-1) === "/" ? "" : "/") + U, n;
  }
  getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  }
  buildReport(n) {
    const t = p();
    return {
      guid: this.uuid,
      ...n,
      applicationId: t.appId,
      timestamp: Date.now(),
      proxyUrl: t.proxyUrl,
      source: t.sourceType
    };
  }
}
export {
  q as Reporter,
  S as SourceType,
  p as getVonageMetadata,
  J as setVonageMetadata
};
